import React from 'react';
import {useTranslation} from 'react-i18next';
import {OFFER_LABELS} from '../../../utils/upselling';
import backgroundPlaceholder from '../../../assets/empty-offer-background.svg';
import {Container, Row, RowSpace, CardRow, Col, Title, Image} from './styled';
import {Label} from '../ExperiencePage/styled';

type CardProps = {
  img: string;
  name: string;
  hours: string;
  spots: string;
  price: string;
  people: string;
  highlight: string;
  desription: string;
  label?: OFFER_LABELS;
};

function ExperienceCard({
  img,
  name,
  hours,
  label,
  people,
  price,
  highlight,
  desription,
  spots,
}: CardProps) {
  const {t} = useTranslation();

  return (
    <Container>
      <CardRow>
        <Col>
          <Image
            style={{
              backgroundImage: `url(${img || backgroundPlaceholder})`,
            }}
          >
            {label && <Label value={label}>{t(label)}</Label>}
          </Image>
        </Col>
        <Col className="productProperties">
          <RowSpace>
            <Title>{name}</Title>
            {/* <PriceLabel> */}
            {/* <div className="oldprice">$000</div> */}
            {/* <div className="newprice">{`$${price}`}</div> */}
            {/* </PriceLabel> */}
          </RowSpace>
          <Row className="hoursandpeopleRow">
            <div>{highlight}</div>
            {/* <div className="hours">{hours}</div>
            <div className="people">{people}</div> */}
          </Row>
          <Row className="desription">{desription}</Row>
          <RowSpace>
            <div className="price">{price}</div>
            {/* <div className="spots">{`$${spots}`}</div> */}
          </RowSpace>
        </Col>
      </CardRow>
    </Container>
  );
}

export default ExperienceCard;
